import * as types from "./mutation_types";

const getLoanOfficers = ({ commit,dispatch }, {name = ""}) => {
    commit(types.TOGGLE_LOADING);
    let url = "/loan-officer/extented/like?term=" + name;

    if(window.location.href.indexOf("localhost") >= 0) {
        url = "http://localhost:9001/app_dev.php/loan-officer/extented/like?term=" + name;
    }

    fetch(url)
    .then((response) => response.json())
    .then((data) => {
      commit(types.SET_LOAN_OFFICERS, data);
      commit(types.TOGGLE_LOADING);
    })
    .catch((e) => {
      commit(types.TOGGLE_LOADING);
      commit(types.SET_ERROR, e.message);
      dispatch('alert/error', e.message, { root: true });
    });
};

export const setLoanOfficerSelected = ({ commit}, {loan_officer}) => {


    commit(types.SET_LOAN_OFFICER_SELECTED, loan_officer);
    /*
    commit(types.TOGGLE_LOADING);
    let url = "/esi/state-license/lo-json/" + loan_officer.id;

    if(window.location.href.indexOf("localhost") >= 0) {
        url = "http://localhost:9001/app_dev.php" + url;
    }

    fetch(url)
        .then((response) => response.json())
        .then((data) => {
            const loan_officer_selected = {
                id: loan_officer.id,
                title: loan_officer.title,
                image: loan_officer.image,
                nmls_id: loan_officer.nmls_id,
                url: loan_officer.url,
                email: loan_officer.email,
                description: loan_officer.description,
                states: data
            };
            commit(types.SET_LOAN_OFFICER_SELECTED, loan_officer_selected);
            commit(types.TOGGLE_LOADING);
        })
        .catch((e) => {
            commit(types.TOGGLE_LOADING);
            commit(types.SET_ERROR, e.message);
            dispatch('alert/error', e.message, { root: true });
        });

    commit(types.SET_LOAN_OFFICER_SELECTED, loan_officer);

     */
};


export default getLoanOfficers;
